export default "__VITE_PUBLIC_ASSET__a7b61fad__"